import React, { useCallback } from 'react';

import { GARNER_NETWORKS } from '../../../consts/teladoc-garner/garnerNetworks';
import { OrderAssistFormInputs, SelectOption } from '../../../types';
import NetworksIcon from '../../../../../assets/search-form/networks.svg';
import SelectLabelValueOption from '../common/SelectLabelValueOption';

import './index.less';

type Props = {
  selectedNetwork?: SelectOption;
  onChange: (input: Partial<OrderAssistFormInputs>) => void;
  validationError?: string;
  isDirty?: boolean;
};

export const NetworkInputWrapper: React.FC<Props> = ({
  selectedNetwork,
  onChange,
  validationError,
  isDirty,
}: Props) => {
  const onNetworkChange = useCallback(
    (network: SelectOption) => {
      onChange({ network });
    },
    [onChange],
  );

  return (
    <div className="select-network-input">
      <SelectLabelValueOption
        className="teladoc-garner-select-network"
        selected={selectedNetwork}
        isDirty={isDirty}
        validationError={validationError}
        items={GARNER_NETWORKS}
        onChange={onNetworkChange}
        wrapperProps={{
          className: 'network-input-wrapper',
          leftIcon: <img src={NetworksIcon} alt="Networks" className="networks-icon" />,
        }}
        selectProps={{
          placeholder: 'Network',
          id: 'network-input',
          name: 'network',
          noResultsLabel: 'No networks found',
        }}
      />
    </div>
  );
};
